document.addEventListener('DOMContentLoaded', () => {


    document.querySelectorAll('.navScrollSimple').forEach(button => {

        button.addEventListener('click', function(e) {

            e.preventDefault();

            const target = document.querySelector(this.dataset.scroll);

            const close = academy.querySelector('.mobile-menu__close');

            if (close) {
                close.click();
            }

            if (!target) return;

            const offset = 80;

            const top = target.getBoundingClientRect().top + window.pageYOffset - offset;

            window.scrollTo({
                top,
                behavior: 'smooth'
            });

        });

    });
});